'use client';

import H1 from '@/components/typography/h1';
import H5 from '@/components/typography/h5';
import P from '@/components/typography/p';
import { StandingOverlay } from '@/components/ui/standing-overlay';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function OurClients() {
    const { t } = useTranslation();
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let scrollLeft = 0;
        const threshold = 10;

        const onTouchStart = (e: TouchEvent) => {
            isDragging = false;
            const touch = e.touches[0];
            if (!touch) return;
            startX = touch.clientX;
            startY = touch.clientY;
            scrollLeft = el.scrollLeft;
        };

        const onTouchMove = (e: TouchEvent) => {
            const touch = e.touches[0];
            if (!touch) return;
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;

            if (
                !isDragging &&
                Math.abs(dx) > Math.abs(dy) &&
                Math.abs(dx) > threshold
            ) {
                isDragging = true;
            }

            if (isDragging) {
                e.preventDefault();
                el.scrollLeft = scrollLeft - dx;
            }
        };

        el.addEventListener('touchstart', onTouchStart, { passive: true });
        el.addEventListener('touchmove', onTouchMove, { passive: false });

        return () => {
            el.removeEventListener('touchstart', onTouchStart);
            el.removeEventListener('touchmove', onTouchMove);
        };
    }, []);

    return (
        <div className="border-primary border-b">
            <div className="relative">
                <StandingOverlay />
                <div className="flex flex-col items-center justify-center gap-3 py-15 lg:gap-5">
                    <div className="z-[1] flex flex-col items-center justify-center gap-3 px-5 lg:gap-5 lg:px-8">
                        <H1>{t('clients.title')}</H1>
                        <P className="text-center lg:max-w-[931px]">
                            {t('clients.description')}
                        </P>
                    </div>

                    <div
                        ref={scrollRef}
                        className="no-scrollbar w-full cursor-grab touch-pan-y overflow-x-auto overflow-y-hidden active:cursor-grabbing xl:hidden"
                    >
                        <div className="mx-auto w-[170vw] px-5">
                            <Image
                                src="/images/standing-food/all.png"
                                alt="all foods"
                                className="pointer-events-none select-none"
                                width={1600}
                                height={755}
                            />
                        </div>
                    </div>
                    <H5 className="mx-auto text-center text-xs normal-case xl:hidden">
                        Swipe om meer te zien
                    </H5>

                    <div className="hidden h-[355px] max-w-full object-scale-down xl:block xl:h-[730px]" />
                </div>
            </div>
        </div>
    );
}

OurClients.displayName = 'OurClients';
export default OurClients;
